import React, { Fragment, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import RenderBasket from "../../Common/RenderBasket";
import MainItems from "./Components/MainItems";
import { GetData } from "./Components/Services";
import { useHome } from "./hooks";

import Mobile from "../../Common/Mobile";
import AdvertisingBoxes from "./Components/AdvertisingBoxes";
import Search from "./Components/Search";
import TwoSliders from "./Components/TwoSliders";
import WhyUs from "./Components/WhyUs";
import Blogs from "./Components/Blogs";
import Text from "./Components/Text";
import { Color } from "../../../Utils/styles";
import { Link } from "react-router-dom";

function Index() {
  const { form, setForm, loading, sendSms } = useHome();
  const initialState = {
    loading: true,
    data: {
      data: null,
    },
    types: [],
    basket: false,
  };
  const dispatch = useDispatch();
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  const basket = useSelector(state => state.basket);

  const [state, setState] = useState(initialState);
  useEffect(() => {
    hanlder();
    scrollToTop();
  }, []);

  const hanlder = async data => {
    setState({ ...state, loading: true });
    await GetData(data).then(result => {
      setState({
        ...state,
        loading: false,
        data: result,
        types: [
          ...new Set(
            result && Array.isArray(result.main_item)
              ? result.main_item.map(pro => pro.type_item)
              : []
          ),
        ],
      });
    });
  };
  // if (state.loading) {
  //   return (
  //     <Helmet>
  //       <title>نیکوتن | خانه </title>
  //       <meta
  //         name="description"
  //         content="نیکوتن | رزرو آنلاین اماکن و کلاس های ورزشی"
  //       />
  //       <link rel="canonical" href={`/`} />
  //     </Helmet>
  //   );
  // }
  return (
    <Fragment>
      <Helmet>
        <title>رزرو استخر، رزرو باشگاه بدنسازی، رزرو سالن ورزشی | نیکوتن</title>
        <meta
          name="description"
          content="نیکوتن جامع ترین سامانه معرفی، اطلاع رسانی و رزرو آنلاین استخر و پارک های آبی، باشگاه های بدنسازی، سالن های ورزشی و کلاس های ورزشی با تخفیف های ویژه ، خرید بلیت استخر و شیفت های باشگاه بدنسازی و سالن های ورزشی"
        />
        <link rel="canonical" href={window.origin + `/`} />
      </Helmet>

      <Search
        landingLoading={state.loading}
        allcitys={state.data && state.data.allcitys}
      />
      <AdvertisingBoxes landingLoading={state.loading} background={true} />
      <MainItems
        data={state && state.data && state.data.main_item}
        types={state && state.types}
        landingLoading={state.loading}
      />
      <TwoSliders landingLoading={state.loading} />
      <WhyUs
        landingLoading={state.loading}
        data={state && state.data && state.data.lastreserve}
      />
      <Mobile landingLoading={state.loading} />
      <Blogs
        landingLoading={state.loading}
        data={state && state.data && state.data.blogs}
      />
      <Text />
      <RenderBasket basket={basket} />

    </Fragment>
  );
}

export default Index;
